import AirportAPI from 'api/airport';

export const SEARCH_SUBMIT = 'SEARCH_SUBMIT';
export const SEARCH_GET_AIRPORTS = 'SEARCH_GET_AIRPORTS';
export const SEARCH_SET_SORT_TYPE = 'SEARCH_SET_SORT_TYPE';
export const SEARCH_UPDATE_TIMES = 'SEARCH_UPDATE_TIMES';
export const SEARCH_TOGGLE_INFO_PANEL_VIEW = 'SEARCH_TOGGLE_INFO_PANEL_VIEW';
export const SEARCH_SET_MAP_INSTANCE = 'SEARCH_SET_MAP_INSTANCE';
export const SEARCH_SET_NO_SPOTS_FOUND = 'SEARCH_SET_NO_SPOTS_FOUND';
export const SEARCH_SET_ZOOM = 'SEARCH_SET_ZOOM';
export const SEARCH_PAN_MAP = 'SEARCH_PAN_MAP';
export const SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE =
    'SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE';

export const getAirports = () => ({
    type: SEARCH_GET_AIRPORTS,
    payload: AirportAPI.getAirports(),
});

export const setSortType = sortBy => ({
    type: SEARCH_SET_SORT_TYPE,
    payload: {sortBy},
});

export const toggleInfoPanelView = isInfoPanelVisible => ({
    type: SEARCH_TOGGLE_INFO_PANEL_VIEW,
    payload: {isInfoPanelVisible},
});

export const toggleMobileListView = isMobileListViewActive => ({
    type: SEARCH_TOGGLE_MOBILE_LIST_VIEW_ACTIVE,
    payload: {isMobileListViewActive},
});

export const setSearchMapInstance = searchMapInstance => ({
    type: SEARCH_SET_MAP_INSTANCE,
    payload: {searchMapInstance},
});

export const setZoom = payload => ({
    type: SEARCH_SET_ZOOM,
    payload,
});

export const panMap = () => ({
    type: SEARCH_PAN_MAP,
    payload: {},
});

export const setNoSpotsFound = showNoSpotsFound => ({
    type: SEARCH_SET_NO_SPOTS_FOUND,
    payload: {showNoSpotsFound},
});
